<div
  class="layout-wrapper"
  [class.layout-static-inactive]="!layoutService.sidebarVisible()"
  [class.layout-mobile-active]="layoutService.mobileSidebarVisible()"
>
  <aside class="layout-sidebar">
    <app-sidebar />
  </aside>

  <div class="layout-main-shell">
    <app-header />

    <div class="layout-main-container">
      <div class="layout-main">
        <router-outlet />
      </div>
      <app-footer />
    </div>
  </div>
<div
    class="layout-mask"
    tabindex="0"
    role="button"
    aria-label="Close sidebar overlay"
    (click)="layoutService.closeMobileSidebar()"
    (keydown.enter)="layoutService.closeMobileSidebar()"
    (keydown.space)="layoutService.closeMobileSidebar()"
  ></div>
</div>
